const MONTHS: Record<string, string[]> = {
  en: [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ],
  nl: [
    'Januari',
    'Februari',
    'Maart',
    'April',
    'Mei',
    'Juni',
    'Juli',
    'Augustus',
    'September',
    'Oktober',
    'November',
    'December',
  ],
  fr: [
    'Janvier',
    'Février',
    'Mars',
    'Avril',
    'Mai',
    'Juin',
    'Juillet',
    'Aout',
    'Septembre',
    'Octobre',
    'Novembre',
    'Décembre',
  ],
};

export const formatMonthTitle = (d: Date, locale: string) => {
  return `${MONTHS[locale][d.getMonth()]} ${d.getFullYear()}`;
};

const pad = (n: number) => (n < 10 ? `0${n}` : n);

export const formatDate = (d: string) => {
  const date = new Date(d);
  return `${pad(date.getDate())}/${pad(
    date.getMonth() + 1,
  )}/${date.getFullYear()}`;
};

export const formatTime = (d: string) => {
  const date = new Date(d);
  return `${pad(date.getHours())}:${pad(date.getMinutes())}`;
};
